import {Component, OnDestroy, OnInit, signal} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router';
import {UtilityService} from '../../../../services/utility/utility.service';
import {NgTemplateOutlet} from '@angular/common';
import {IconifyComponent} from '../../../iconography/iconify/iconify.component';
import {filter} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
  selector: 'bor-app-header',
  imports: [
    RouterLink,
    RouterLinkActive,
    NgTemplateOutlet,
    IconifyComponent
  ],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  showMobileMenu = signal(false);
  private routeSub!: Subscription;

  constructor(
    public utility: UtilityService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.routeSub = this.router?.events
      ?.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      ?.subscribe((event) => this.showMobileMenu.set(false))
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

}
